import styled from 'styled-components';
import { PlainButtonBar, PrimaryButton } from './Button';
import { Spacer } from '../editor/EditorHelpers';

export interface InfoDialogProps {
  isOpen: boolean;
  onOk?: () => void;
  message: string;
  title: string;
}

export const InfoDialog: React.FC<InfoDialogProps> = ({ 
  isOpen, onOk, message, title
}) => {
  if (!isOpen) return null;

  return (
    <DialogOverlay>
      <DialogContent>
        <DialogHeader>{title}</DialogHeader>
        <DialogMessage>{message}</DialogMessage>
        <PlainButtonBar>
          <Spacer style={{flexGrow: 1}} />
          <PrimaryButton onClick={onOk}>OK</PrimaryButton>
          <Spacer style={{flexGrow: 1}} />
        </PlainButtonBar>
      </DialogContent>
    </DialogOverlay>
  );
};

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(32, 32, 32, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DialogContent = styled.div`
  background: var(--bg-color);
  padding: 2rem;
  max-width: 350px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const DialogHeader = styled.h2`
  margin: 0.5rem 0 0 0;
`;

const DialogMessage = styled.p`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;


